export default "__VITE_ASSET__CNPSD9n6__"